import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef, } from '@angular/core'
import { FacetComponent, FacetGroupCollapsedState, FacetService } from '@spartacus/storefront'
import {
  triggerSmoothCollapseAnimation
} from '../../../../shared/animations/smooth-collapse.animation'
import { FacetValue } from '@spartacus/core'
import { map } from 'rxjs/operators'
import { Subscription } from 'rxjs'
import { ActivatedRoute } from '@angular/router'
import { MbSpinnerService } from '../../../../shared/services/mb-spinner.service'
import { DeviceDetectorService } from 'ngx-device-detector'

@Component({
  selector: 'mb-facet',
  templateUrl: './mb-facet.component.html',
  styleUrls: ['./mb-facet.component.scss'],
  animations: [triggerSmoothCollapseAnimation],
})
export class MbFacetComponent extends FacetComponent implements OnInit {

  facetState = FacetGroupCollapsedState
  subscription = new Subscription()
  queryContent: string | undefined
  isDesktopDevice = this.deviceDetectorService.isDesktop()

  constructor (protected facetService: FacetService,
               protected elementRef: ElementRef<HTMLElement>,
               protected cd: ChangeDetectorRef,
               protected route: ActivatedRoute,
               protected mbSpinnerService: MbSpinnerService,
               protected vcr: ViewContainerRef,
               protected deviceDetectorService: DeviceDetectorService) {
    super(facetService, elementRef, cd)
  }

  ngOnInit (): void {
    this.state$ = this.facetService.getState(this.facet).pipe(
      map(state => {
        const facetLength: number | undefined = this.facet.values?.length
        if (!state.maxVisible || !state.topVisible || !facetLength) {
          return state
        }
        let maxVisible = state.maxVisible
        if ((state.maxVisible > state.topVisible) && (state.maxVisible < facetLength)) {
          maxVisible = facetLength
        }
        return {
          ...state,
          maxVisible
        }
      })
    )
  }

  toggleGroup (event: UIEvent) {
    const isLocked = this.keyboardFocus?.isLocked
    this.facetService.toggle(this.facet, this.isExpanded)
    if (!isLocked || this.isExpanded) {
      event.stopPropagation()
    }
  }

  getLinkParams (value: FacetValue) {
    const { queryContent } = this.route.snapshot.queryParams
    return {
      ...super.getLinkParams(value),
      queryContent
    }
  }

  onFacetClick () {
    this.mbSpinnerService.launchMbSpinner(this.vcr)
  }
}
